import { OnboardingDocumentTypeEnum } from 'src/features/onboarding/types/upload-documents';
import { PaymentTypes } from './application/payment';

export enum PAGE_CHANNEL {
  SELF_SERVICE = 'vodapay: self service',
  TAP_ON_PHONE = 'tap on phone app',
  BUY_POS = 'buy pos',
  VODAPAY_BUY_POS = 'vodapay: buy pos',
}

export enum PAGE_SUB_DOMAIN {
  SELF_SERVICE = 'vodapay: self service',
  TAP_ON_PHONE = 'tap on phone onboarding',
  BUY_POS = 'buy pos',
}

export enum PAGE_SECTION {
  SELF_SERVICE = 'self service',
  BUY_POS = 'buy pos',
  TAP_ON_PHONE = 'tap on phone onboarding',
}

export enum PAGE_TYPE {
  WEBSITE = 'website',
  WEBVIEW = 'webview',
}

export enum VISITOR_CUSTOMER_TYPE {
  CONSUMER = 'consumer',
  BROKER = 'pos distribution',
  AGENT = 'store agent',
}

export enum EVENT_NAME {
  PAGE_VIEW = 'page_view',
  UI_INTERACTION = 'ui_interaction',
  JOURNEY_START = 'journey_start',
  JOURNEY_STEP = 'journey_step',
  JOURNEY_END = 'journey_end',
  CHECKOUT_START = 'checkout_start',
  CHECKOUT_COMPLETE = 'checkout_complete',
  TRANSACTION_COMPLETE = 'transaction_complete',
  SMME_APPLICATION_COMPLETE = 'smme_application_complete',
  PRO_ONBOARDING_COMPLETE = 'pro_onbording_complete',
  PRODUCT_VIEW = 'product_view',
  CART_VIEW = 'cart_view',
  CART_ADD = 'cart_add',
  CART_REMOVE = 'cart_remove',
  FORM_START = 'form_start',
  FORM_END = 'form_end',
  FORM_ERROR = 'form_error',
  MERCHANT_ONBOARDING_COMPLETE = 'merchant_onboarding_complete',
  TOOL_START = 'tool_start',
  SUPPORT_ISSUE_RAISED = 'support_issue_raised',
  PAGE_ERROR = 'page_error',
  EVENT_ERROR = 'event_error',
}

export enum FORM_NAME_PREFIX {
  BUY_POS = 'vodapay: buy pos: ',
  SELF_SERVICE = 'vodapay: smme: self service: ',
  ONBOARDING = 'vodapay: smme: self service: onboarding: ',
  PENDING_APPLICATION = 'vodapay: smme: self service: pending application: ',
  TOP_ONBOARDING = 'vodapay: top: onboarding: ',
}

export enum FORM_NAME {
  PERSONAL_DETAILS = 'personal details',
  COMPANY_DETAILS = 'company details',
  DIRECTOR_INFORMATION = 'director information',
  BANKING_DETAILS = 'bank details',
  PERSONAL_DETAILS_CONFIRM = 'personal details: confirmation',
  ABOUT_YOUR_BUSINESS = 'merchant onboarding: about your business',
  COMPANY_ADDRESS = 'merchant onboarding: company address',
  ABOUT_YOUR_DIRECTORS = 'merchant onboarding: about your directors',
  ONBOARDING_PERSONAL_DETAILS = 'merchant onboarding: personal details',
  RESIDENTIAL_ADDRESS = 'merchant onboarding: residential address',
  BANK_DETAILS = 'merchant onboarding: bank details',
  CONFIRM_PERSONAL_DETAILS = 'merchant onboarding: personal details confirmation',
  DELIVERY_ADDRESS = 'delivery address',
}

export enum JOURNEY_NAME {
  BUY_POS = 'buy pos',
  THIRD_PARTY = 'buy pos: 3rd party',
  TAP_ON_PHONE = 'tap on phone onboarding',
  DEVICE_ACTIVATION = 'register device',
  PENDING_APPLICATION = 'pending application',
  CONTINUE_APPLICATION = 'continue application',
  MERCHANT_ONBOARDING = 'merchant onboarding',
  THIRD_PARTY_ONBOARDING = '3rd party merchant onboarding',
  THIRD_PARTY_ACCOUNT_CREATION = '3rd party account creation',
}

export enum JOURNEY_STEP_NAME {
  WEBCAM_ENABLE = 'webcam enable',
  ENTER_BARCODE = 'enter barcode',
  ASSIGN_NAME = 'name your card machine',
  ASSIGN_NAME_CONFIRMATION_MODAL = 'name your card machine: delete device',
  COMPANY_DETAILS = 'company details',
  DIRECTOR_INFORMATION = 'director information',
  PERSONAL_DETAILS_CONFIRM = 'personal details: confirmation',
  SELFIE_CAPTURE = 'selfie capture',
  TAKE_PHOTO = 'take photo',
  BANK_DETAILS = 'bank details',
  UPLOAD_DOCUMENTS = 'upload documents',
  ORDER_SUMMARY = 'order summary',
  SMS_OTP = 'sms otp',
  SET_PASSWORD = 'set password',
}

export enum JOURNEY_TYPE {
  SELF_SERVICE = 'self service',
  ONBOARDING = 'onboarding',
}

export enum PAGE_NAME_PREFIX {
  BUY_POS = 'vodapay: buy pos: ',
  SELF_SERVICE = 'vodapay: smme: self service: ',
  ONBOARDING = 'vodapay: smme: self service: onboarding: ',
  PENDING_APPLICATION = 'vodapay: smme: self service: pending application: ',
  TOP_ONBOARDING = 'vodapay: top: onboarding: ',
}

export enum PAGE_NAME {
  // ORDER JOURNEY
  ORDER_SUMMARY = 'order summary',
  ORDER_COMPLETE = 'order complete',

  // ONBOARDING JOURNEY
  ACCOUNT_CREATION = 'account creation',
  CHOOSE_SOLUTION = 'choose solution',
  CONFIRM_PERSONAL_DETAILS = 'confirm personal details',
  PERSONAL_DETAILS = 'personal details',
  ADD_DELIVERY_ADDRESS = 'add delivery address',
  CHANGE_DELIVERY_ADDRESS = 'change delivery address',
  WEBCAM = 'webcam',
  ENABLE_WEBCAM = 'enable webcam',
  NAME_CARD_MACHINE = 'name card machine',
  DELETE_DEVICE = 'delete device',
  DEVICE_OFFER = 'device offer',
  ENTER_BARCODE = 'enter barcode',
  ASSIGN_NAME = 'name your card machine',
  TENDER_TYPE = 'tender type',
  ASSIGN_NAME_CONFIRMATION_MODAL = 'name your card machine: delete device',
  ASSIGN_DELIVERY_ADDRESS = 'assign delivery address',
  GET_STARTED = 'get started',
  SETUP_YOUR_ACCOUNT = 'setup your account',
  ABOUT_YOUR_BUSINESS = 'about your business',
  ABOUT_YOUR_DIRECTORS = 'about your directors',
  PERSONAL_DETAILS_CONFIRM = 'personal details: confirmation',
  COMPANY_DETAILS = 'company details',
  BUSINESS_DETAILS = 'business details',
  RESIDENTIAL_ADDRESS = 'residential address',
  COMPANY_ADDRESS = 'company address',
  DIRECTOR_DETAILS = 'director details',
  COMPANY_DIRECTOR_DETAILS = 'company details: director details',
  BANK_DETAILS = 'bank details',
  CONFIRM_ADDRESS = 'confirm address',
  PERSONAL_SELFIE = 'personal selfie',
  SELFIE_CAPTURE = 'selfie capture',
  SELFIE_CAPTURED = 'selfie captured',
  SELFIE_CAPTURE_OPEN_CAMERA = 'selfie capture: open camera',
  SELFIE_SCREEN = 'selfie capture: selfie screen',
  SELFIE_CAPTURE_WEBCAM = 'selfie capture: enable webcam',
  UPLOAD_DOCUMENTS = 'upload documents',
  SETUP_COMPLETION = 'setup completion',
  UPDATE_PENDING_APPLICATION = 'update pending application',
  ONBOARDING_COMPLETE = 'onboarding complete',
  ONBOARDING_FAILED = 'onboarding failed',
  EXIT_MODAL = 'exit modal',
  UNDER_18 = 'user under 18 modal',
  APPLICATION_DECLINED = 'application declined',
  CALCULATE_FEES = 'calculate fees pop up',
  MONTHLY_TURNOVER = 'calculate your fees: monthly turnover',
  ALMOST_THERE = 'almost there',
  PENDING_APPLICATION = 'pending application',
  PAYMENT_REQUEST = 'payment request',
  PAYMENT_GATEWAY = 'payment gateway',
  PAYMENT_FAILED = 'payment failed',
}

export enum LINK_PREFIX {
  BUY_POS = 'vodapay: buy pos: ',
  SELF_SERVICE = 'vodapay: smme: self service: ',
  ONBOARDING = 'vodapay: smme: self service: onboarding: ',
  TOP_ONBOARDING = 'vodapay: top: onboarding: ',
}

export enum LINK_NAME {
  ACCOUNT_CREATION = 'account creation',
  GET_STARTED = 'get started',
  SETUP_YOUR_ACCOUNT = 'setup your account',
  CHOOSE_SOLUTION = 'choose solution',
  PERSONAL_DETAILS = 'personal details',
  ORDER_SUMMARY = 'order summary',
  WEBCAM = 'webcam',
  ENABLE_WEBCAM = 'enable webcam',
  NAME_CARD_MACHINE = 'name card machine',
  CHECKOUT = 'checkout',
  TENDER_TYPE = 'tender type',
  CHANGE_DELIVERY_ADDRESS = 'change delivery address',
  ADD_DELIVERY_ADDRESS = 'add delivery address',
  SHOW_BUSINESS_ADDRESS = 'show business address',
  ENTER_BARCODE = 'enter barcode',
  ADD_NEW_DEVICE = 'name your card machine: add another machine',
  DELETE_DEVICE = 'name your card machine: delete device',
  DEVICE_OFFER = 'device offer',
  ASSIGN_NAME_NEXT = 'name your card machine: next',
  ASSIGN_NAME_CONFIRMATION_MODAL = 'name your card machine: delete device',
  ASSIGN_DELIVERY_ADDRESS = 'assign delivery address',
  LOG_OUT = 'logout',
  CLOSE_APPLICATION = 'close application',
  CLOSE_MODAL = 'close modal',
  CALCULATE_YOUR_FEES = 'calculate your fees',
  MORE_ABOUT_CP_CNP = 'more about cp and cnp',
  SELECT_TURNOVER_AMOUNT = 'select turnover amount',
  COMPANY_DETAILS = 'company details',
  DIRECTOR_DETAILS = 'director details',
  COMPANY_DIRECTOR_DETAILS = 'company details: director details',
  PERSONAL_DETAILS_CONFIRM = 'personal details: confirmation',
  TAKE_PHOTO = 'take photo',
  SELFIE_CAPTURE = 'selfie capture',
  SELFIE_CAPTURED = 'selfie captured',
  SELFIE_CAPTURE_OPEN_CAMERA = 'selfie capture: open camera',
  SELFIE_SCREEN = 'selfie capture: selfie screen',
  SELFIE_SCREEN_TAKE_PHOTO = 'selfie capture: selfie screen: take photo',
  SELFIE_CAPTURE_WEBCAM_BACK = "selfie capture: enable webcam: i'll be back",
  SELFIE_CAPTURE_WEBCAM_ENABLED = "selfie capture: enable webcam: i've enabled it",
  SELFIE_CAPTURE_NEXT = 'selfie capture: next',
  BANK_DETAILS = 'bank details',
  BANK_DETAILS_NEXT = 'bank details: next',
  BANK_DETAILS_VERIFY_FAILED = 'banking details verification failed',
  UPLOAD_DOCUMENTS = 'upload documents',
  UPLOAD_DOCUMENTS_NEXT = 'upload document: next',
  DOCUMENT_UPLOADED = 'document uploaded',
  ABOUT_BUSINESS = 'about your business: back',
  ABOUT_YOUR_BUSINESS = 'about your business',
  RESIDENTIAL_ADDRESS = 'residential address',
  CONFIRM_PERSONAL_DETAILS = 'confirm personal details',
  TOOL_TIP = 'tooltip',
  CONFIRM = 'confirm',
  NEXT = 'next',
  ADD_DIRECTOR = 'add director',
  UPDATE_PENDING_APPLICATION_EXIT = 'update pending application: exit',
  UPDATE_PENDING_APPLICATION_CALL = 'update pending application: call support',
  UPDATE_PENDING_APPLICATION_EMAIL = 'update pending application: email support',
  HELP = 'help',
  CALL_SUPPORT = 'call support number',
  EMAIL_SUPPORT = 'email support',
  PAYMENT_REQUEST = 'payment request',
  PAYMENT_FAILED = 'payment failed',
  ERROR_TOOL_TIP = 'update pending application: error tooltip',
  ERROR_TOOL_TIP_CONTACT = 'update pending application: error tooltip: contact number',
  ERROR_TOOL_TIP_NEXT = 'update pending application: error tooltip: next',
  ERROR_TOOL_TIP_PREVIOUS = 'update pending application: error tooltip: previous',
}

export enum PAGE_ERROR_NAME {
  INCORRECT_BARCODE = 'incorrect barcode entered',
  INSUFFICIENT_FUNDS = 'insufficient funds',
  GATEWAY_TIMEOUT = 'gateway timeout',
  SCANNING_FAILED = 'scanning failed',
  APPLICATION_UNSUCCESSFUL = 'application unsuccessful',
  APPLICATION_PENDING = 'application pending',
}

export enum PAGE_ERROR_TYPE {
  USER_ERROR = 'user error',
  SYSTEM_ERROR = 'system error',
}

export enum PAGE_ERROR_CODE {
  NA = 'N/A',
}

export enum FORM_ERROR_NAME {
  INCORRECT_OTP = 'incorrect otp entered',
  FAILED_TO_SET_PASSWORD = 'failed to set password',
  EXPIRED_OTP = 'expired otp',
}

export enum FORM_ERROR_TYPE {
  USER_ERROR = 'user error',
  SYSTEM_ERROR = 'system error',
}

export enum BuyOption {
  BUY = 'Buy',
  RENT = 'Rent',
}

export type StaticVariables = {
  page_url: string;
  page_section: PAGE_SECTION;
  page_channel: PAGE_CHANNEL;
  page_subdomain: PAGE_SUB_DOMAIN;
  page_type: PAGE_TYPE;
  product_name?: string | string[];
  visitor_customer_type?: VISITOR_CUSTOMER_TYPE;
};

type Event = {
  event_name: (EVENT_NAME | OnboardingDocumentTypeEnum)[];
} & StaticVariables;

export type View = {
  page_name:
    | `${PAGE_NAME_PREFIX}${string}`
    | `${PAGE_NAME_PREFIX}${PAGE_NAME}`
    | `${PAGE_NAME_PREFIX}${PAGE_NAME}: ${string}`;
  form_name?: FORM_NAME | `${FORM_NAME_PREFIX}${FORM_NAME}`;
  journey_name: JOURNEY_NAME;
  journey_type?: JOURNEY_TYPE;
  journey_step_name?: JOURNEY_STEP_NAME;
  product_name?: string | string[];
  product_category?: string;
  transaction_id?: string;

  form_completion_rate?: string;
  form_field_incomplete?: string;
  page_error_name?: PAGE_ERROR_NAME;
  page_error_type?: PAGE_ERROR_TYPE;
  page_error_code?: PAGE_ERROR_CODE;
  event_error_name?: string;
  event_error_type?: string;
  event_error_code?: string;
  form_error_name?: FORM_ERROR_NAME;
  form_error_type?: FORM_ERROR_TYPE;
  form_error_code?: number;
  tool_name?: string;
  tool_type?: string;
  tool_error?: string;
  citizenship_type?: string;
} & Event;

export type Link = {
  link_page_name?: `${PAGE_NAME_PREFIX}${PAGE_NAME}` | `${PAGE_NAME_PREFIX}${PAGE_NAME}: ${string}`;
  page_name?:
    | `${PAGE_NAME_PREFIX}${string}`
    | `${PAGE_NAME_PREFIX}${PAGE_NAME}`
    | `${PAGE_NAME_PREFIX}${PAGE_NAME}: ${string}`;
  form_name?: FORM_NAME | `${FORM_NAME_PREFIX}${FORM_NAME}`;
  journey_name: JOURNEY_NAME;
  journey_step_name?: JOURNEY_STEP_NAME;
  // LINK_ID and LIN_NAME is the same
  link_id?: LINK_NAME | `${LINK_PREFIX}${LINK_NAME}` | `${LINK_PREFIX}${LINK_NAME}: ${string}`;
  link_name?:
    | LINK_NAME
    | `${LINK_PREFIX}${string}`
    | `${LINK_PREFIX}${LINK_NAME}`
    | `${LINK_PREFIX}${LINK_NAME}: ${string}`;
  event_label?: string;
  event_category?: string;
  event_action?: string;
  event_error_name?: string;
  event_error_code?: string;
  event_error_type?: string;
  product_name?: string | string[];
  product_variant?: string;
  tool_name?: string;
  tool_input?: string;
  tool_type?: string;
  tool_error?: string;
  citizenship_type?: string;
  form_completion_rate?: string;
  form_field_incomplete?: string;
  form_error_name?: FORM_ERROR_NAME;
  form_error_type?: FORM_ERROR_TYPE;
  form_error_code?: number;
  payment_preference?: PaymentTypes;
  tender_type?: string;
  transaction_id?: string | undefined;
} & Event;
